<template>
	<div class="panel-body">
		<slot />
	</div>
</template>
